import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import classnames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'reactstrap';
import Icon from '../common/containers/icon';
import entityComposition from '../common/classes/entityComposition';
import { checkCanEditPermissions } from './reportSelectors';
const ReportsRow = _ref => {
  let _ref$data = _ref.data,
    id = _ref$data.id,
    statusName = _ref$data.statusName,
    canEditReport = _ref$data.canEditReport,
    statusDate = _ref$data.statusDate,
    preview = _ref$data.preview,
    firstName = _ref$data.firstName,
    lastName = _ref$data.lastName,
    reportTypeName = _ref$data.reportTypeName,
    jobNumber = _ref$data.jobNumber,
    reportNumber = _ref$data.reportNumber,
    appCreated = _ref$data.appCreated,
    reportType = _ref$data.reportType,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    index = _ref.index,
    hasActions = _ref.hasActions,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    isSelected = _ref.isSelected,
    onEditClick = _ref.onEditClick,
    onSelect = _ref.onSelect,
    onClick = _ref.onClick,
    user = _ref.user,
    _ref$isDeleted = _ref.isDeleted,
    isDeleted = _ref$isDeleted === void 0 ? false : _ref$isDeleted;
  const handleEditClick = () => !isDeleted && onEditClick(id);
  const handleSelect = event => onSelect(id, event);
  const handleClick = () => !isDeleted && onClick(id);

  // if not editable (i.e. no content), moot point.
  const isReportBuilder = () => canEditReport;
  const isEditable = checkCanEditPermissions(user, {
    identifier: reportType
  }, {
    identifier: statusName.toLowerCase(),
    _created: statusDate
  });
  let checkbox;
  let editColumn;
  const rowClass = classnames({
    disabled,
    deleted: isDeleted
  }, "t-rr-".concat(index));
  const rowSpan = preview ? 3 : 1;
  const colSpan = preview ? 3 : 1;
  // if preview is set create two rows to maintain striping
  const previewRow = preview ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null), /*#__PURE__*/React.createElement("tr", {
    className: "".concat(rowClass, "-preview")
  }, /*#__PURE__*/React.createElement("td", {
    colSpan: colSpan
  }, preview))) : null;
  if (isReportBuilder()) {
    // there are three cases.
    editColumn = /*#__PURE__*/React.createElement("td", {
      rowSpan: rowSpan,
      style: _objectSpread({
        verticalAlign: 'middle',
        textAlign: 'center',
        width: '30px'
      }, isDeleted ? {
        opacity: 0.5
      } : {})
    }, isEditable && !isDeleted && /*#__PURE__*/React.createElement(NavLink, {
      onClick: handleEditClick
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: readOnly ? 'eye' : 'pencil-alt',
      className: "t-rr-edit"
    })));
  } else {
    editColumn = /*#__PURE__*/React.createElement("td", {
      "aria-label": "edit-report-button",
      onClick: isDeleted ? undefined : handleClick,
      role: isDeleted ? undefined : 'button',
      style: isDeleted ? {
        opacity: 0.5
      } : {}
    });
  }
  if (hasActions) {
    checkbox = /*#__PURE__*/React.createElement("td", {
      "aria-label": "select-report-checkbox",
      rowSpan: rowSpan,
      style: {
        width: '1px',
        verticalAlign: 'middle'
      }
    }, /*#__PURE__*/React.createElement("input", {
      className: "t-rr-check",
      type: "checkbox",
      checked: isSelected,
      onChange: handleSelect
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: rowClass
  }, checkbox, /*#__PURE__*/React.createElement("td", {
    className: "t-rr-reportnumber t-rr-reportnumber-".concat(reportNumber),
    onClick: isDeleted ? undefined : handleClick,
    role: isDeleted ? undefined : 'button',
    style: isDeleted ? {
      opacity: 0.5,
      cursor: 'default'
    } : {}
  }, "".concat(reportTypeName, " ").concat(reportNumber), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", null, jobNumber)), /*#__PURE__*/React.createElement("td", {
    onClick: isDeleted ? undefined : handleClick,
    role: isDeleted ? undefined : 'button',
    style: isDeleted ? {
      opacity: 0.5,
      cursor: 'default'
    } : {}
  }, "".concat(firstName, " ").concat(lastName), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", null, moment(appCreated).format('MM/DD/YYYY'))), /*#__PURE__*/React.createElement("td", {
    onClick: isDeleted ? undefined : handleClick,
    role: isDeleted ? undefined : 'button',
    style: isDeleted ? {
      opacity: 0.5,
      cursor: 'default'
    } : {}
  }, /*#__PURE__*/React.createElement("span", {
    className: "t-rr-".concat(index, "-statusName"),
    style: statusName === 'Rejected' ? {
      color: 'red'
    } : {}
  }, statusName), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", null, moment(statusDate).format('MM/DD/YYYY'))), editColumn), previewRow);
};
ReportsRow.propTypes = {
  data: PropTypes.shape({
    appCreated: PropTypes.string,
    canEditReport: PropTypes.number,
    firstName: PropTypes.string,
    id: PropTypes.string,
    jobNumber: PropTypes.string,
    lastName: PropTypes.string,
    preview: PropTypes.string,
    reportNumber: PropTypes.number,
    reportType: PropTypes.string,
    reportTypeName: PropTypes.string,
    statusName: PropTypes.string,
    statusDate: PropTypes.string
  }).isRequired,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  hasActions: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isDeleted: PropTypes.bool,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  user: PropTypes.shape({
    permissions: PropTypes.shape({}),
    user_id: PropTypes.string
  }).isRequired
};
export { ReportsRow as TestReportsRow };
export default entityComposition(ReportsRow, [], {
  user: state => state.login.user
}, []);